
import { defineComponent, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useJobTitleModule } from '@/modules/job-titles'
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { JobTitle } from '@/modules/job-titles/types'
import JobTitlesFormFieldJobTitle from '@/components/job-titles/form-fields/job-title.vue'
import { requiredRule, useFormModule } from '@/modules/_shared/forms'
import { JobTitlesRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'job-titles-edit-job-title-form',
    components: { JobTitlesFormFieldJobTitle },
    async setup (props, { emit }) {
        const $q = useQuasar()
        const { submitForm, createOnSuccess } = useFormModule()
        const { getSingleJobTitle, updateJobTitle, deleteJobTitle } = useJobTitleModule()
        const route = useRoute()

        const jobTitle = await getSingleJobTitle(route.params.id as string)

        const jobTitleModel = reactive<JobTitle>({
            id: jobTitle.id,
            title: jobTitle.title
        })

        const form = ref<QForm>()
        const emitEvent = () => emit('formSent')

        const sendForm = async () => updateJobTitle(jobTitleModel.id.toString(), jobTitleModel)

        const onSubmit = () => submitForm(
            form.value,
            sendForm,
            createOnSuccess('Job title updated!')
        ).then(emitEvent)

        async function onDeleteJobTitle () {
            await deleteJobTitle(route.params.id as string)
            $q.notify({
                color: 'positive',
                message: 'Selected member has been deleted'
            })
        }

        return {
            requiredRule,
            onSubmit,
            jobTitleModel,
            form,
            onDeleteJobTitle,
            JobTitlesRouteNames,
            route
        }
    }
})
